import React from "react";
import HowItWorksImage from "../assets/img/howitworks2.png";
import Cashback from "../assets/img/cash-back.png";


export default function ExpressOfInterestLandingPage() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* HERO */}
      <section className="bg-gradient-to-br from-purple-700 via-indigo-700 to-indigo-800 text-white">
        <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Safe. Transparent.<br />Digital Community Finance.
            </h1>
            <p className="text-xl max-w-xl mb-8">
              MastaKash is onboarding early adopters who want a safer, smarter way to save, lend, and manage money — individually, in groups, and through trusted agents.
            </p>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeS0SOBOOyxJQCTHPtdgjFU4sL5PsiZit4PlgCGQk8ZrLUEZg/viewform" target="_blank">
              <button className="bg-orange-500 hover:bg-orange-600 transition text-white font-semibold px-8 py-4 rounded-2xl shadow-lg">
                Join Early Access (Express Interest)
              </button>
            </a>
          </div>
          <div className="hidden md:block">
            <img
              src={HowItWorksImage}
              alt="Community finance illustration"
              className="rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* WHO IS THIS FOR */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <h2 className="text-3xl font-semibold mb-10 text-center">
          Is MastaKash for You?
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-3">For Individuals</h3>
            <ul className="space-y-2 text-sm">
              <li>Lost money due to chama fraud or mismanagement</li>
              <li>Belong to multiple groups and struggle to track finances</li>
              <li>Want transparent savings, loans, and merry-go-rounds</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-3">For Groups & Chamas</h3>
            <ul className="space-y-2 text-sm">
              <li>Managing members using notebooks or WhatsApp</li>
              <li>Frequent disputes and lack of accountability</li>
              <li>Need bank grade governance without without even a bank account</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-3">For Agents</h3>
            <ul className="space-y-2 text-sm">
              <li>Looking for a trusted income opportunity</li>
              <li>Register and support groups in your community</li>
              <li>Enable cash-in and cash-out services</li>
            </ul>
          </div>
        </div>
      </section>

      {/* WHAT WE ARE DOING */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 py-20 text-center">
          <h2 className="text-3xl font-semibold mb-6">What MastaKash Is Doing</h2>
          <p className="text-lg max-w-4xl mx-auto">
            MastaKash is onboarding early adopters who want to eliminate fraud, digitize group finance, and build trust through rules — not promises — ahead of full public launch.
          </p>
        </div>
      </section>

      {/* WHAT IS MASTAKASH */}
      <section className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl font-semibold mb-6">What Is MastaKash?</h2>
          <p className="text-lg mb-4">
            MastaKash is a digital community finance infrastructure platform that enables individuals and groups to safely save, lend, transfer money, and manage contributions using regulated financial rails.
          </p>
          <p className="text-lg">
            It introduces governance, auditability, consumer protection, and compliance controls into everyday informal financial practices — without forcing banking.
          </p>
        </div>
        <div>
          <img
            src={Cashback}
            alt="Secure digital wallets"
            className="rounded-2xl shadow-xl"
          />
        </div>
      </section>

      {/* BENEFITS BY SEGMENT */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <h2 className="text-3xl font-semibold mb-12 text-center">What You Get</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-2xl shadow">
              <h3 className="font-semibold mb-3">Individuals</h3>
              <p className="text-sm">
                Manage all your groups in one place, participate in savings, loans, and merry-go-rounds, get statements, insights, dividends, and enjoy zero risk of fund misuse.
              </p>
             {/* <a href="https://docs.google.com/forms/d/e/1FAIpQLSeS0SOBOOyxJQCTHPtdgjFU4sL5PsiZit4PlgCGQk8ZrLUEZg/viewform" className="inline-block mt-4 text-purple-700 font-medium" target="_blank">
                Join as an Individual →
              </a>*/}
            </div>
            <div className="bg-gray-50 p-6 rounded-2xl shadow">
              <h3 className="font-semibold mb-3">Groups & Chamas</h3>
              <p className="text-sm">
                Onboard members digitally, create rules and loan products, automate approvals, eliminate disputes, and scale beyond geography with audit-ready records.
              </p>
             {/* <a href="https://docs.google.com/forms/d/e/1FAIpQLSeS0SOBOOyxJQCTHPtdgjFU4sL5PsiZit4PlgCGQk8ZrLUEZg/viewform" className="inline-block mt-4 text-purple-700 font-medium" target="_blank">
                Join as a Group →
              </a>*/}
            </div>
            <div className="bg-gray-50 p-6 rounded-2xl shadow">
              <h3 className="font-semibold mb-3">Agents</h3>
              <p className="text-sm">
                Earn commissions by registering users and groups, managing deposits and withdrawals, and serving as a trusted financial access point in your community.
              </p>
             {/* <a href="https://docs.google.com/forms/d/e/1FAIpQLSeS0SOBOOyxJQCTHPtdgjFU4sL5PsiZit4PlgCGQk8ZrLUEZg/viewform" className="inline-block mt-4 text-purple-700 font-medium" target="_blank">
                Join as an Agent →
              </a>*/}
            </div>
          </div>
        </div>
      </section>

      {/* DIFFERENTIATORS */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <h2 className="text-3xl font-semibold mb-10 text-center">What Makes MastaKash Different</h2>
        <ul className="grid md:grid-cols-2 gap-6 text-lg">
          <li>✔ Ring-fenced group wallets — no commingling, no abuse</li>
          <li>✔ Works for informal, semi-formal, and formal groups</li>
          <li>✔ Progressive formality — not forced banking</li>
          <li>✔ Group + individual financial rails</li>
          <li>✔ Agent network for physical reach</li>
          <li>✔ Built for regulation, scale, and supervision</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="bg-purple-700 text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 text-center">
          <h2 className="text-3xl font-bold mb-6">Join the Early Access Program</h2>
          <p className="mb-8 text-lg">
            Express your interest today. No payment. No obligation. Priority onboarding post-licensing.
          </p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeS0SOBOOyxJQCTHPtdgjFU4sL5PsiZit4PlgCGQk8ZrLUEZg/viewform" target="_blank">
            <button className="bg-orange-500 hover:bg-orange-600 transition text-white font-semibold px-10 py-4 rounded-2xl shadow-lg">
              Express Interest – Join Early Access
            </button>
          </a>
        </div>
      </section>
    </div>
  );
}
